<template>
	<div>
		<div class="add-event-step-header">Sponsors</div>
		<v-layout row wrap>
		<v-flex md6 xs11>
			<div v-for="item in items" :key="item.index">
				<div v-if="item.index === items.length-1">
					<v-text-field v-model="item.name" class="ml-2 pr-4 add-event-text-box" label="Sponsor Name"></v-text-field>
					<v-text-field v-model="item.website" class="ml-2 pr-4 add-event-text-box" label="Sponsor Website"></v-text-field>
					<v-textarea v-model="item.description" class="ml-2 pr-4 add-event-text-box" label="Description"></v-textarea>
					<input 
						class="image-dropzone"
						type="file" 
						accept="image/*" 
						:multiple="false" 
						ref="fileInput"
						@change="onFilePicked"
						required
					/>
				</div>
			</div>
		</v-flex>
		<v-flex md4 hidden-xs-only>
			<v-list>
				<v-list-tile avatar v-for="item in getAddEventProp('sponsors')" :key="item.title">
					<v-list-tile-avatar>
						<img v-bind:src="item.photoUrl"/>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title v-text="item.name"></v-list-tile-title>
						<v-list-tile-sub-title v-text="item.description"></v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-flex>
		</v-layout>
		<v-btn class="add-event-save-continue-button" @click="addAnother">Add Another</v-btn>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			items: [
				{
					index: 0,
					name: null,
					website: null,
					description: null,
					photoUrl: null,
					photo: null
				}
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
	methods: {
		...mapActions([
			'setAddEventWrkprtyType',
			'setAddEventProp',
			'addEventProcessFilesSponsor',
			'setAddEventSponsor'
		]),
		addAnother() {
			let imgUrl = this.getAddEventProp('tempSponsorImageUrl')
			let img = this.getAddEventProp('tempSponsorImage')
			this.items[this.items.length - 1].photoUrl = imgUrl
			this.items[this.items.length - 1].photo = img
			this.setAddEventSponsor(this.items[this.items.length - 1])
			this.items.push({
				index: this.items.length,
				name: null,
				website: null,
				description: null,
				photoUrl: null,
				photo: null
			})
			console.log(this.items)
		},
		onFilePicked(event) {
			this.addEventProcessFilesSponsor(event.target.files)
		}
	},
	computed: {
		...mapGetters(['getAddEventWrkprtyType', 'getAddEventProp']),
		typeSelection: {
			get() {
				return this.getAddEventWrkprtyType
			},
			set(val) {
				this.setAddEventWrkprtyType(val)
			}
		}
	}
}
</script>

<style>
</style>
